<template>
  <div v-if="demandes">
    <b-modal
      id="modalSelect"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      size="xl"
      :title="titleModal"
    >
      <template #default>
        <div class="row d-flex justify-content-center">
          <div class="col-md-6">
            <div class="form-group">
              <label for="demande"
                >Référence demande <span class="text-danger">*</span></label
              >
              <v-custom-select
                label="reference"
                :options="demandes"
                :reduce="(demande) => demande.uuid"
                v-model="demande"
                placeholder="Référence demande"
                @input="onSelectedDemande"
              >
                <template v-slot:option="{ date, reference, destination }">
                  <h5 style="margin: 0">{{ reference }}</h5>
                  <span v-if="date" class="d-block">
                    Date : {{ date | formatDate('DD/MM/YYYY') }}
                  </span>

                  <span v-if="destination" class="d-block">
                    Entrepôt de destination : {{ destination.nom }}
                  </span>
                </template>
                <template #no-options> Aucune donnée </template>
                <template #search="{ attributes, events }">
                  <input
                    id="demande"
                    class="custom-select-height vs__search"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-custom-select>
            </div>
          </div>
        </div>
      </template>
      <template #modal-footer>
        <button
          type="button"
          class="btn btn-danger mr-2"
          @click="$bvModal.hide('modalSelect')"
        >
          Fermer
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import URL from '@/http/gpao/transfert';
export default {
  data() {
    return {
      demande: null,
      demandes: [],
      titleModal: "Sélection d'une demande de transfert",
    };
  },
  props: ['currentDemande'],
  methods: {
    onSelectedDemande() {
      if (this.demande) {
        let currentDemande = window._.find(
          this.demandes,
          (c) => c.uuid === this.demande
        );

        this.$emit('onSelectedDemande', this.demande, {
          date: currentDemande.date,
          reference: currentDemande.reference,
          id: currentDemande.id,
          uuid: currentDemande.uuid,
          destination: currentDemande.destination,
          destination_uuid: currentDemande.destination_uuid,
        });
        this.$bvModal.hide('modalSelect');
      }
    },
    async showModal() {
      this.demande = this.currentDemande;
      this.demandes = [];

      await window.axios
        .get(URL.GET_DEMANDES)
        .then((resp) => {
          this.demandes = resp.data.demandes;
        })
        .catch();

      await this.$bvModal.show('modalSelect');
    },
  },
};
</script>

<style scoped lang="scss"></style>
